<template>
    <div class="ui-content dashboard leader-sub">
        <div class="readymadetest-name-search">
            <div class="search-test-name">
                <v-text-field
                  v-model="testName"
                  @keydown="onSearchTest()"
                  solo
                  label="Test Name"
                  dense
                  outlined
                  hide-details
                  append-icon="search"
                  autocomplete="off"
                ></v-text-field>
            </div>
        </div>
        <div>
            <ReadyMadeTestsList />
        </div>
    </div>
</template>

<script>
import ReadyMadeTestsList from "@/components/student/Tests/PastTests/ReadyMadeTestsList.vue";
// import PreviousYearTest from "@/components/student/Tests/PastTests/PreviousYearTest.vue";
import { mapState, mapMutations } from "vuex";
export default {
    name: "Notification",
    components: {
        ReadyMadeTestsList
    },
    mounted() {
        this.defaultData();
        this.checkSessionData();
    },
    computed: {
        ...mapState("userStore", ["user"])
    },
    data() {
        return {
            testTypesList: [{ text: "Institute Tests", value: "institute" }],
            selectedTest: null
        };
    },
    methods: {
        ...mapMutations("app", ["addBreadCrumbChilde"]),
        defaultData() {
            // this.selectedTest = this.testTypesList[0].value;
            if (this.types.GOLD === this.user.type) {
                this.testTypesList.push({ text: "Premium Tests", value: "premium" });
            }
            let routeName = this.$route.name;
            let crd = this.getCurrentRouteDetails(routeName); 
            if(crd) {
                this.selectedTest = crd.selectedTab ? crd.selectedTab : this.testTypesList[0].value;
            }
        },        
        checkSessionData() {
            let rp = this.$route; // route params
            let crd = this.getCurrentRouteDetails(rp.name);
            
            if(rp.params.resetPage || !crd.routeName) {
                let details = {
                            page: 1,
                            orderBy: {
                                field: "started",
                                order: "DESC"
                            },
                            examTypes: []
                        };
                let tabDetail = {
                    premium: _.cloneDeep(details),
                    institute: _.cloneDeep(details)           
                };
                tabDetail.premium.orderBy.field = 'test_name';
                tabDetail.premium.orderBy.order = 'ASC';

                let routeDetails = {
                    routeName: rp.name,
                    selectedTab: this.selectedTest,
                    tabDetails: tabDetail
                }
                this.setRouteDetails(routeDetails);
            }
            this.defaultData();
        },
    },
    watch: {
        selectedTest(val, oldVal) {
            // let breadCrumb = val == "premium" ? "Premium Tests" : "Institute Tests";
            // if(oldVal) { // only when tab is changed and not on page load
            //     let routeName = this.$route.name;
            //     this.setRouteDetails({routeName, selectedTab: val});
            // }            
            this.addBreadCrumbChilde([
                {
                    text: breadCrumb,
                    disabled: false
                }
            ]);
        }
    }
};
</script>